export default __webpack_public_path__ + "static/media/MAngry.5722a5bb.svg";